/**
 * Intelligence Prism Constants (DC-1368)
 *
 * Station metadata, driver colors, and severity colors.
 * Extracted from IntelligencePrism.tsx.
 */

import type { LucideIcon } from 'lucide-react';
import { BarChart3, Search, Building2, Cpu, Network } from 'lucide-react';

import type { StationId, DriverType, MetricSeverity } from './types';

// DC-1586 follow-up: Lucide icons across the Prism for Epic F consistency.
// Same mapping table as StationActionPanel + StationCard so a Compass user
// can move between the Strategic tab and the Stations tab without seeing two
// different icon families.
export const STATION_META: Record<StationId, { name: string; icon: LucideIcon; shortName: string }> = {
  data_quality: { name: 'Data Quality', icon: BarChart3, shortName: 'DQ' },
  live_checks: { name: 'Live Checks', icon: Search, shortName: 'FAIR' },
  org_context: { name: 'Org Context', icon: Building2, shortName: 'Org' },
  ml_readiness: { name: 'ML Readiness', icon: Cpu, shortName: 'ML' },
  ontology_inference: { name: 'Ontology', icon: Network, shortName: 'Onto' },
};

// Cream/teal tokens (v2.0 fold) — four DISTINCT family hues so the Pistoia
// drivers stay tellable-apart on the cream ground: COST=good, SPEED=terra,
// QUALITY=teal, EFFECTIVENESS=soft.
export const DRIVER_COLORS: Record<DriverType, { bg: string; border: string; text: string }> = {
  COST: { bg: 'var(--tri-good-bg)', border: 'var(--tri-good)', text: 'var(--tri-good)' },
  SPEED: { bg: 'rgba(var(--tri-terra-rgb), 0.12)', border: 'var(--tri-terra)', text: 'var(--tri-terra)' },
  QUALITY: { bg: 'var(--tri-teal-tint)', border: 'var(--tri-teal)', text: 'var(--tri-teal)' },
  EFFECTIVENESS: { bg: 'var(--tri-soft-bg)', border: 'var(--tri-soft)', text: 'var(--tri-soft)' },
};

export const SEVERITY_COLORS: Record<MetricSeverity, { bg: string; border: string }> = {
  success: { bg: 'var(--tri-good)', border: 'var(--tri-good)' },
  info: { bg: 'var(--tri-neutral)', border: 'var(--tri-neutral)' },
  warning: { bg: 'var(--tri-soft)', border: 'var(--tri-soft)' },
  critical: { bg: 'var(--tri-hard)', border: 'var(--tri-hard)' },
};
